import { BudgetAllowance } from '@frontend/budget/types';
import { Spinner } from '@frontend/components/common';
import { IGroup } from '@frontend/group/types';
import { Group } from '@frontend/group/utils';
import { CommonMessage } from '@frontend/lang';
import { StockAvailability } from '@frontend/stock/types';

import { useLeafCategoryCard } from './leaf-category-card.controller';

export interface LeafCategoryCardProps {
    category?: IGroup;
    category_id?: string;
    onClick?: (category: IGroup) => void;
    categoryAvailability?: StockAvailability | null;
    categoryAllowance?: BudgetAllowance | null;
}

export const LeafCategoryCard = (props: LeafCategoryCardProps) => {
    const viewProps = useLeafCategoryCard(props);

    if (!viewProps.category) {
        return (
            <div className='bg-background-surface outline-border-default inline-flex w-full items-start justify-start gap-3 self-stretch rounded-xl p-4 outline-1 -outline-offset-1'>
                <Spinner />
            </div>
        );
    }

    const isUnavailable = props.categoryAvailability !== undefined && props.categoryAvailability !== null && !props.categoryAvailability.available;
    const isOutOfBudget = props.categoryAllowance !== undefined && !props.categoryAllowance?.allowed;
    const isDisabled = isUnavailable || isOutOfBudget;

    return (
        <div
            onClick={() => !isDisabled && props.onClick && props.onClick(viewProps.category!)}
            className={`bg-background-surface outline-border-default inline-flex w-full items-start justify-start gap-3 self-stretch rounded-xl p-3 outline-1 -outline-offset-1 ${isDisabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
            <div className='flex w-full flex-col gap-3'>
                <div className='flex gap-4'>
                    <div className='relative h-20 w-20'>
                        <img
                            className={`aspect-square h-full w-full rounded-lg object-contain`}
                            src={viewProps.image ?? viewProps.placeholder}
                            alt={viewProps.category.name}
                        />
                    </div>
                    <div className='inline-flex flex-1 flex-col items-start justify-start gap-3'>
                        <div className='flex h-10 flex-col items-start justify-start gap-1 self-stretch'>
                            <div className={`text-foreground-default justify-start self-stretch text-base font-medium`}>
                                {new Group(viewProps.category).getName(viewProps.locale)}
                            </div>
                        </div>
                        <div className='flex w-full gap-1'>
                            {isOutOfBudget && (
                                <div className='bg-status-warning inline-flex items-start justify-center gap-1 rounded-full px-2 py-1'>
                                    <div className='text-background-surface justify-start text-center text-sm font-semibold'>
                                        {CommonMessage.ERRORS.NOT_IN_BUDGET}
                                    </div>
                                </div>
                            )}
                            {isUnavailable && (
                                <div className='bg-brand-disabled inline-flex items-start justify-center gap-1 rounded-full px-2 py-1'>
                                    <div className='text-background-surface justify-start text-center text-sm font-semibold'>
                                        {CommonMessage.ERRORS.OUT_OF_STOCK}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
